<template lang="pug">
.profile-container
    v-card.info-profile
        v-card-title
            | Información General
        v-card-text
            v-container
                v-row
                    v-col.data-profile
                        span 
                            strong Nombre: 
                            | {{ name }}
                        br
                        span 
                            strong E-mail: 
                            | {{ email }}
                        br
                        span 
                            strong Edad: 
                            | {{ age }}
                        br
                        span
                            strong Genero: 
                            |{{ gender }}
    
    v-card(v-if='exams.length > 0')
        v-card-title 
            | Examenes Disponibles
        v-data-table.elevation-1(:headers='examsHeaders' :items='exams' )
            template(v-slot:item.action='{ item }')
                v-icon.mr-2(small='' @click='goToExam(item)')
                    | open_in_new

    v-card
        v-card-title 
            | Evaluaciones
        v-data-table.elevation-1(:headers='headers' :items='evaluations' )
            template(v-slot:item.action='{ item }')
                v-icon.mr-2(small='' @click='showEvaluation(item)')
                    | open_in_new
            template(v-slot:item.review='{ item }')
                v-icon.mr-2(small='' @click='reviewExam(item)')
                    | check
    



</template>

<script>
import { config } from '../config.js'

export default {
    data: () => ({
        name: '',
        email: '',
        age:'',
        gender: '',
        user: {},
        exams: [],
        examsHeaders: [
          {
            text: 'Nombre del Examen',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          { text: 'Realizar examen', value: 'action', sortable: false }
        ],
        headers: [
            { text: 'Id del Examen', value: 'exam_id', sortable: false },
            { text: 'Fecha de evaluación', value: 'createDate', sortable: true },
            { text: 'Total', value: 'total_rate', sortable: true },
            { text: 'Aciertos', value: 'totals', sortable: true },
            { text: 'Reporte', value: 'action', sortable: false },
            { text: 'Revision', value: 'review', sortable: false }
        ],
        evaluations: []
    }),
    created(){
        this.initialize();
    },
    methods:{
        initialize(){
            this.$emit("loadingEvent", true);

            this.user = JSON.parse(localStorage.getItem('user'));

            this.axios.get(`${config.serviceUri}students?userId=${this.user.id}`)
            .then( (response) => {
                console.log('Succes request: ',response.data);
                this.user.info = response.data.payload;
                this.name = this.user.info.name + this.user.info.lastName;
                this.gender = this.user.info.gender;
                this.age = this.user.info.age;
                this.email = this.user.info.email;
                
            })
            .catch( (error) => {
                console.log('Error: ', error);
                this.$emit("loadingEvent", false);
            });

            this.axios.get(`${config.serviceUri}exams?idUser=${this.user.id}`)
                .then( (response) => {
                    console.log('Succes request Exams: ',response.data);
                    this.exams = response.data.payload;
                })
                .catch( (error) => {
                    console.log('Error: ', error);
                    this.$emit("loadingEvent", false);
                });

            this.axios.get(`${config.serviceUri}evaluations?filter={"user_id":"${this.user.id}"}`)
                .then( (response) => {
                    console.log('Succes request: ',response.data);
                    this.evaluations = response.data.payload;
                    this.$emit("loadingEvent", false);
                })
                .catch( (error) => {
                    console.log('Error: ', error);
                    this.$emit("loadingEvent", false);
                });
            
        },
        showEvaluation(item){
            console.log(item);
            this.$router.push({ name: 'indiv-results', query: { id: item.id } });
        },
        reviewExam(item){
            console.log(item);
            this.$router.push({ name: 'checkLanTest', query: { id: item.id } });
        },
        goToExam(item){
            console.log(item);
            this.$router.push({ name: 'lanTest', query: { id: item.id } });
        }
    }
}
</script>

<style scoped>

    .info-profile{
        margin: 20px 0;
    }

    .profile-img img{
        max-width: 150px;
        max-height: 150px;
    }

    .data-profile{
        font-size: 1.2rem;
    }
</style>
